// SPDX-FileCopyrightText: Copyright (c) 2025 Software GmbH, Darmstadt, Germany and/or its subsidiaries and/or its affiliates
// SPDX-FileContributor: Zead Alshukairi (planen-bauen 4.0 GmbH)
//
// SPDX-License-Identifier: Apache-2.0

import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatTreeModule } from "@angular/material/tree";
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';

import { SpinnerComponent } from "./components/elems/spinner/spinner.component";
import { JsonRendererComponent } from "./components/elems/json-renderer/json-renderer.component";
import { PopUpComponent } from './components/elems/pop-up/pop-up.component';
import { NotificationComponent } from './components/elems/notification/notification.component';
import { DialogConfirmComponent } from './components/dialogs/dialog-confirm/dialog-confirm.component';
import { MatDialogModule } from '@angular/material/dialog';
import { TreeComponent } from './components/elems/tree/tree.component';
import { CertificationTemplateTreeViewerComponent } from "./components/certification-template-tree-viewer/certification-template-tree-viewer.component";
import { MatChipsModule } from "@angular/material/chips";
import { MatExpansionModule } from "@angular/material/expansion";
import { SpanButtonComponent } from './components/form-elems/span-button/span-button.component';
import { ExpandableTableComponent } from './components/elems/expandable-table/expandable-table.component';
import { SwitcherComponent } from './components/form-elems/switcher/switcher.component';


@NgModule({
  imports: [
    TranslateModule.forChild(),
    CommonModule,
    ReactiveFormsModule,
    FormsModule,

    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatButtonToggleModule,
    MatTreeModule,
    MatExpansionModule,
    MatChipsModule,
    MatDialogModule,
    MatTreeModule,
    MatTableModule,
    MatTooltipModule,
    SpinnerComponent,
    JsonRendererComponent,
    PopUpComponent,
    NotificationComponent,
    DialogConfirmComponent,
    TreeComponent,
    CertificationTemplateTreeViewerComponent,
    SpanButtonComponent,
    ExpandableTableComponent,
    SwitcherComponent
  ],
  exports: [
    TranslateModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,

    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatButtonToggleModule,
    MatDialogModule,
    MatTreeModule,
    MatChipsModule,
    MatExpansionModule,
    MatTableModule,
    MatTooltipModule,

    SpinnerComponent,
    JsonRendererComponent,
    PopUpComponent,
    NotificationComponent,
    SpanButtonComponent,
    TreeComponent,
    CertificationTemplateTreeViewerComponent,
    DialogConfirmComponent,
    ExpandableTableComponent,
    SwitcherComponent
  ]
})
export class SharedModule { }
